import { FC, memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { SubdelegatedRole } from 'models/interface/subdelegated'

import { ButtonsWrapper, ConfirmationWrapper } from '../styles'

type Props = {
  role?: SubdelegatedRole | null
  onAccept: () => void
  onCancel: () => void
}

const roleLabel: Record<SubdelegatedRole, string> = {
  [SubdelegatedRole.ADMINISTRATOR]: 'administrador',
  [SubdelegatedRole.OPERATOR]: 'membro'
}

export const Confirmation: FC<Props> = memo(({ role, onAccept, onCancel }) => (
  <ConfirmationWrapper>
    <Text as="h2" size="heading4" weight="medium">
      Confirmar participação
    </Text>
    <Text size="body1">
      Você foi convidado para participar do <strong>Programa de Substabelecidos</strong> da CashMe.
    </Text>
    <Text size="body1">
      Ao aceitar o convite, seu cadastro atual<strong>{role ? ` como ${roleLabel[role]}` : ''}</strong> será encerrado e
      as informações vinculadas a esse CNPJ não poderão ser recuperadas.
    </Text>
    <Text size="body1">Deseja continuar?</Text>
    <ButtonsWrapper>
      <Button size="lg" color="secondary" onClick={onCancel}>
        Cancelar
      </Button>
      <Button size="lg" onClick={onAccept}>
        Aceitar convite
      </Button>
    </ButtonsWrapper>
  </ConfirmationWrapper>
))

Confirmation.displayName = 'Confirmation'
